<template>
  <v-layout row wrap>
    <!-- Dialog -->
    <v-dialog v-model="json_data.status" fullscreen transition="dialog-bottom-transition" :overlay="false">
      <v-card style="background-color:#EEEEEE;">
        <v-toolbar dark color="primary">
          <v-tooltip bottom>
            <v-btn slot="activator" icon dark @click="closeDialog">
              <v-icon>close</v-icon>
            </v-btn>
            <span>{{$t('close')}}</span>
          </v-tooltip>
          <v-toolbar-title>{{ json_data.save_type == 'create' ? $t('menu.DeviceSettingCreate') :
            $t('menu.DeviceSettingEdit') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn flat dark @click="json_data.save_type == 'create' ? onSave() : onUpdate()">
            <v-icon>save</v-icon>
            <span class="px-2">{{ json_data.save_type == 'create' ? $t('create') : $t('save') }}</span>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container background fluid pa-4>
            <v-layout row wrap pa-4 style="background-color:#fff; margin-top:5px; border-radius:5px;">
              <v-flex xs12>
                <v-form ref="form" v-model="form_valid">
                  <v-layout row wrap>
                    <v-flex md6 sm6 xs12 pa-1>
                      <v-text-field name="รหัสเครื่องสแกนนิ้ว" label="รหัสเครื่องสแกนนิ้ว" v-model="form_model.device_code"
                        :rules="form_rules.device_code" v-if="json_data.save_type == 'create' " required append-icon="fas fa-plus-circle"
                        hide-details @click:append="doNewGuid" />
                      <v-text-field v-else name="รหัสเครื่องสแกนนิ้ว" label="รหัสเครื่องสแกนนิ้ว" v-model="form_model.device_code"
                        :rules="form_rules.device_code" :readonly="true" required append-icon="fas fa-plus-circle"
                        hide-details />
                    </v-flex>

                    <v-flex md6 sm6 xs12 pa-1>
                      <v-text-field name="ชื่อเครื่อง" label="ชื่อเครื่อง" v-model="form_model.name" :rules="form_rules.name"
                        required placeholder="Ex: เครื่อง11" hide-details />
                    </v-flex>
                    <v-flex xs12 pa-1>
                      <v-textarea name="หมายเหตุ" label="หมายเหตุ" v-model="form_model.remark" hide-details />
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-layout row wrap>
            <v-flex xs12 text-xs-right pa-3>
              <v-btn color="success" @click="json_data.save_type == 'create' ? onSave() : onUpdate()">
                <v-icon>save</v-icon>
                <span class="px-2">{{ json_data.save_type == 'create' ? $t('create') : $t('save') }}</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Snackbar -->
    <v-snackbar v-model="snack_model.status" :timeout="3500" :top="'top'" :color="snack_model.type">
      {{ snack_model.msg }}
      <v-btn dark flat icon @click="snack_model.status = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>
<script>
  /* eslint-disable */
  import {
    mapActions
  } from 'vuex';
  import SettingService from "@/services/SettingService";
  import Utils from "@/utils/";

  export default {
    props: {
      json_data: Object
    },
    watch: {
      json_data(val) {
        if (val.data != null) {
          this.form_model = val.data;
        } else {
          this.$refs.form.resetValidation();
          this.doNewGuid();
        }
      }
    },
    data: () => ({
      form_valid: false,
      form_model: {
        device_code: "",
        name: "",
        remark: "",
        creator_code: localStorage._usercode
      },
      form_rules: {
        device_code: [v => !!v || "do not empty."],
        name: [v => !!v || "do not empty."]
      },
      snack_model: {
        status: "",
        msg: "",
        type: ""
      }
    }),
    methods: {
      ...mapActions("alert", ["commitToggleAlertDialog"]),
      closeDialog() {
        this.clearForm();
        this.$emit("close-dialog");
      },
      doNewGuid() {
        this.form_model.device_code = Utils.newGuid('SC');
      },
      clearForm() {
        this.form_model = {
          device_code: "",
          name: "",
          remark: "",
          creator_code: localStorage._usercode
        }
      },
      showSnackBar(msg, type) {
        this.snack_model.msg = msg;
        this.snack_model.type = type;
        this.snack_model.status = true;
      },
      onSave() {
        if (this.form_valid) {
          SettingService.createNewDevice(this.form_model).then(res => {
            this.showSnackBar('save success', 'success');
            this.closeDialog();
          }).catch(err => {
            this.showSnackBar(err.response.data, 'error');
          });
        } else {
          this.$refs.form.validate();
        }
      },
      onUpdate() {
        if (this.form_valid) {
          SettingService.updateDevice(this.form_model).then(res => {
            this.showSnackBar('update success', 'success');
            this.closeDialog();
          }).catch(err => {
            this.showSnackBar(err.response.data, 'error');
          });
        } else {
          this.$refs.form.validate();
        }
      }
    }
  };
</script>